(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["iamfit-product-alignment"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('iamfit-product-alignment')) {
    customElements.define('iamfit-product-alignment', class extends HTMLElement {
      connectedCallback() {
        this.cardSelector = 'product-block.product-block:not(.product-block--compact):not(.product-block--landscape)';
        this.parts = [
          ['.product-block__title', '--iamfit-title-height'],
          ['.product-price', '--iamfit-price-height'],
          ['.iamfit-atc-btn', '--iamfit-button-height'],
          ['.product-block__detail .innerer > .product-link', '--iamfit-info-height']
        ];
        this.observed = new Map();
        this.schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.align());
        };
        this.resize = new ResizeObserver(entries => {
          let changed = false;
          entries.forEach(entry => {
            const width = entry.contentRect.width;
            if (this.observed.get(entry.target) !== width) {
              this.observed.set(entry.target, width);
              changed = true;
            }
          });
          if (changed) this.schedule();
        });
        this.changes = new MutationObserver(records => {
          const relevant = records.some(record => {
            const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
            const card = target?.closest(this.cardSelector);
            if (card && !card.closest('.ffcp')) return true;
            return [...record.addedNodes, ...record.removedNodes].some(node =>
              node.nodeType === 1 && !node.closest('.ffcp') &&
              (node.matches(this.cardSelector) || node.querySelector(this.cardSelector))
            );
          });
          if (relevant) this.schedule();
        });
        this.changes.observe(document.body, {childList: true, subtree: true, characterData: true});
        this.onLoad = event => {
          const card = event.target.closest?.(this.cardSelector);
          if (card && !card.closest('.ffcp')) this.schedule();
        };
        document.addEventListener('load', this.onLoad, true);
        document.addEventListener('shopify:section:load', this.schedule);
        window.addEventListener('resize', this.schedule, {passive: true});
        document.fonts?.addEventListener('loadingdone', this.schedule);
        document.fonts?.ready.then(() => {
          if (this.isConnected) this.schedule();
        });
        this.schedule();
      }
      layoutTop(element) {
        let top = 0;
        for (let node = element; node; node = node.offsetParent) top += node.offsetTop;
        return top;
      }
      align() {
        if (!this.isConnected) return;
        const cards = Array.from(document.querySelectorAll(this.cardSelector)).filter(card =>
          !card.closest('.ffcp') && card.querySelector('.iamfit-card-atc') &&
          card.querySelector('.product-block__detail .innerer > .product-link')
        );
        const containers = new Map();
        cards.forEach(card => {
          card.classList.add('iamfit-aligned-card');
          this.parts.forEach(([, property]) => card.style.removeProperty(property));
          card.style.removeProperty('--iamfit-detail-offset');
          const container = card.closest('.product-grid, .product-list') || card.parentElement;
          if (!containers.has(container)) containers.set(container, []);
          containers.get(container).push(card);
        });
        this.observed.forEach((_, container) => {
          if (!containers.has(container)) {
            this.resize.unobserve(container);
            this.observed.delete(container);
          }
        });
        const rows = [];
        containers.forEach((items, container) => {
          if (!this.observed.has(container)) {
            this.observed.set(container, null);
            this.resize.observe(container);
          }
          const groups = [];
          items.forEach(card => {
            if (!card.getClientRects().length || !card.offsetWidth) return;
            const top = this.layoutTop(card);
            let group = groups.find(candidate => Math.abs(candidate.top - top) < 2);
            if (!group) {
              group = {top, cards: []};
              groups.push(group);
            }
            group.cards.push(card);
          });
          groups.forEach(group => rows.push(group.cards));
        });
        const offsets = rows.map(row => row.map(card =>
          this.layoutTop(card.querySelector('.product-block__detail .innerer > .product-link')) - this.layoutTop(card)
        ));
        rows.forEach((row, index) => {
          const maximum = Math.max(...offsets[index]);
          row.forEach((card, position) => card.style.setProperty('--iamfit-detail-offset', `${maximum - offsets[index][position]}px`));
        });
        this.parts.forEach(([selector, property]) => {
          const heights = rows.map(row => Math.ceil(Math.max(0, ...row.map(card =>
            card.querySelector(selector)?.getBoundingClientRect().height || 0
          ))));
          rows.forEach((row, index) => row.forEach(card => card.style.setProperty(property, `${heights[index]}px`)));
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.resize?.disconnect();
        this.changes?.disconnect();
        document.removeEventListener('load', this.onLoad, true);
        document.removeEventListener('shopify:section:load', this.schedule);
        window.removeEventListener('resize', this.schedule);
        document.fonts?.removeEventListener('loadingdone', this.schedule);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
